import { Helmet } from "react-helmet";
import BreadCrumbLatest from "../../components/latestOffer/BreadCrumbLatest";
import Content from "../../components/latestOffer/Content";
import Footer from "../../components/shared/Footer";
import Navbar from "../../components/shared/Navbar";
import RightBar from "../../components/shared/RightBar";

export default function LatestOffer() {
    return (
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <title>Penawaran terkini - BPR Palu Anugerah</title>
                <meta name="description" content="Temukan berbagai penawaran menarik dari BPR Palu Anugerah untuk memenuhi kebutuhan finansial Anda." />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Penawaran terkini - BPR Palu Anugerah" />
                <meta property="og:description" content="Temukan berbagai penawaran menarik dari BPR Palu Anugerah untuk memenuhi kebutuhan finansial Anda." />
                <meta property="og:type" content="website" />
            </Helmet>
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <BreadCrumbLatest></BreadCrumbLatest>
                <Content></Content>
            </main>
            <Footer />
        </div>
    )
}